/*!
 * All material copyright ESRI, All Rights Reserved, unless otherwise specified.
 * See https://github.com/Esri/calcite-design-system/blob/dev/LICENSE.md for details.
 * v2.13.2
 */
export const SLOTS = {
    menuActions: "menu-actions",
    menuTooltip: "menu-tooltip",
};
export const ICONS = {
    menu: "ellipsis",
};
export const CSS = {
    container: "container",
};
//# sourceMappingURL=resources.js.map
